import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * "Retour" qui préserve les filtres de la liste d'origine.
 *
 * Les listes (quotas, frais de déplacement) gardent recherche/filtre/page dans l'URL. Un
 * navigate('/quotas') en dur repartirait donc sur une liste vierge : on remonte plutôt d'un
 * cran dans l'historique, ce qui restitue l'URL exacte d'où l'on vient — même comportement
 * que le bouton Retour du navigateur.
 *
 * Repli sur `fallbackPath` quand il n'y a pas d'historique à remonter : onglet neuf, lien
 * collé, rafraîchissement. React Router laisse location.key à 'default' dans ce cas.
 *
 * @param {string} fallbackPath route de liste à utiliser sans historique
 * @returns {() => void}
 */
export const useBackToList = (fallbackPath) => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (location.key && location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  }, [navigate, location.key, fallbackPath]);
};
